var lib_core = require("lib-core");

/**
 * @constructor
 */
var PanningStateMachine = function (root, panningModel) {
    var self = this;
    this.root = root;
    this.panningModel = panningModel;
    this.editorModel = panningModel.parent().parent();
    this.cameraModel = panningModel.parent();

    lib_core.StateMachine.call(self, null, null, this.panningModel.scope());

    this.panStartTransition = self.addTransition("idle", "mouse_down",
        function(cEvent){
            return cEvent.type() == lib_core.GuiEvents.CANVAS_MOUSE_DOWN && !cEvent.data('shiftKey');
        },
        function(cEvent){
            self.startX = cEvent.data('mouseCoord').getX();
            self.startY = cEvent.data('mouseCoord').getY();
            self.panningModel.onPanStart();
        }, "Start panning"
    );

    this.addTransition("idle", "mouse_down",
        function(cEvent) {
            return cEvent.type() == lib_core.GuiEvents.ELEMENT_MOUSE_DOWN_VIEWMODUS;
        },
        function(cEvent) {
            if (!cEvent.data('notFocusable')) self.cameraModel.addElementInFocus(cEvent.element());

            // since moving components is not possible in view mode: start panning even when you click on components
            self.startX = cEvent.data('mouseCoord').getX();
            self.startY = cEvent.data('mouseCoord').getY();
            self.panningModel.onPanStart();
        }
    );

    this.addTransition("mouse_down", "panning",
        function(cEvent){
            return cEvent.type() == lib_core.GuiEvents.EDITOR_MOUSE_MOVE;
        },
        function(cEvent){
            self.panningModel.changeView((cEvent.data('mouseCoord').getX() - self.startX) / self.cameraModel.viewS(), (cEvent.data('mouseCoord').getY() - self.startY) / self.cameraModel.viewS(), 1.0);

            self.startX = cEvent.data('mouseCoord').getX();
            self.startY = cEvent.data('mouseCoord').getY();
        }
    );

    this.panClickTransition = self.addTransition("mouse_down", "idle",
        function(cEvent){
            return cEvent.type() == lib_core.GuiEvents.CANVAS_MOUSE_UP;
        },
        function(cEvent){
            self.panningModel.onPanClick();
        }
    );

    this.addTransition("panning", "panning",
        function(cEvent){
            return cEvent.type() == lib_core.GuiEvents.EDITOR_MOUSE_MOVE;
        },
        function(cEvent){
            self.panningModel.changeView((cEvent.data('mouseCoord').getX() - self.startX) / self.cameraModel.viewS(), (cEvent.data('mouseCoord').getY() - self.startY) / self.cameraModel.viewS(), 1.0);

            self.startX = cEvent.data('mouseCoord').getX();
            self.startY = cEvent.data('mouseCoord').getY();
        }
    );

    this.addTransition("panning", "idle",
        function(cEvent){
            return cEvent.type() == lib_core.GuiEvents.CANVAS_MOUSE_UP;
        },
        function(cEvent){
            self.panningModel.onPanStop();
        },
        null,
        "" // extend scope of panningStateMachine
    );

    self.addTransition("idle", "touching_canvas",
        function(cEvent){
            return cEvent.type() == lib_core.GuiEvents.EDITOR_TOUCH_PAN_START;
        },
        function(cEvent){
            self.viewX_start = self.cameraModel.viewX();
            self.viewY_start = self.cameraModel.viewY();
        }
    );

    // todo does this ever happen?
    self.addTransition("touching_canvas", "idle",
        function(cEvent){
            return cEvent.type() == lib_core.GuiEvents.EDITOR_TOUCH_PAN_END;
        },
        function(cEvent){
            self.panningModel.onPanClick();
        }
    );

    this.addTransition("touching_canvas", "touch_panning",
        function(cEvent){
            return cEvent.type() == lib_core.GuiEvents.EDITOR_TOUCH_PAN;
        },
        function(cEvent){
            var viewX = self.viewX_start + cEvent.data('gesture').deltaX / self.cameraModel.viewS();
            var viewY = self.viewY_start + cEvent.data('gesture').deltaY / self.cameraModel.viewS();
            var viewS = self.cameraModel.viewS();
            self.panningModel.setView(viewX, viewY, viewS);

            self.panningModel.onPanStart();
        }
    );

    this.addTransition("touch_panning", "touch_panning",
        function(cEvent){
            return cEvent.type() == lib_core.GuiEvents.EDITOR_TOUCH_PAN;
        },
        function(cEvent){
            var viewX = self.viewX_start + cEvent.data('gesture').deltaX / self.cameraModel.viewS();
            var viewY = self.viewY_start + cEvent.data('gesture').deltaY / self.cameraModel.viewS();
            var viewS = self.cameraModel.viewS();
            self.panningModel.setView(viewX, viewY, viewS);
        }
    );

    this.addTransition("touching_panning", "idle",
        function(cEvent){
            return cEvent.type() == lib_core.GuiEvents.EDITOR_TOUCH_PAN_END;
        },
        function(cEvent){
            self.panningModel.onPanStop();
        }
    );
};
lib_core.inherit(PanningStateMachine, lib_core.StateMachine);

module.exports = PanningStateMachine;
